



































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import BudgetItem from "@/models/porposal/budgetItem.model";
@Component
export default class BudgetItemAdd extends GenericAdd<BudgetItem> {
  constructor() {
    super();
    this.controller = "BudgetItem";
    this.model = new BudgetItem();
  }
  protected async validate() {
    try {
      this.model.budgetExpenseId = this.$route.params.budgetExpenseId as any;
      var result = await this.$validator.validateAll();
      if (result) {
        this.add();
        return;
      }
      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }
}
